(function($) {
    //not sure if we need anything or not yet
    $(document).ready(function() {
        /*if( $('#image-cycle').length ){
            $('#image-cycle').cycle();
        }*/

        //expand all accordion
        $(".accordion_toggle").on('click', function() {
            var $this = $(this),
            $this_accordion = $this.parent('ul.accordion');

            $this_accordion.foundation('toggle',$this_accordion.find('.accordion-content'));

            //change the text on the button
            $this.toggleClass('expand_tabs');
            if($this.hasClass('expand_tabs')){
                $this.text('Close All');
            } else {
                $this.text('Expand All');
            }
        });

    }); 

    $(document).on('click', 'a.authorized-site__link', function(e){
        e.preventDefault();
        var authorized_link = $(this).attr('href');
        var current_session = document.cookie.match(/PHPSESSID=[^;]+/)[0];
        //console.log(current_session);
        var current_session_split = current_session.split('=');
        //console.log( 'current session split:' + current_session_split );
        var session_to_pass = current_session_split[1];

        create_and_submit_session_form( authorized_link, 'post', { PHPSESSID: session_to_pass } );

    });

    function create_and_submit_session_form( action, method, input ){
        'use strict';
        var form;
        form = $('<form />', {
            action: action,
            method: 'post',
            style: 'display: none;'
        });
        if (typeof input !== 'undefined' && input !== null) {
          $.each(input, function (name, value) {
            $('<input />', {
                type: 'hidden',
                name: name,
                value: value
            }).appendTo(form);
          });
        }
        form.appendTo('body').submit();
    }


})(jQuery);
